import { type FocusEvent, type FocusEventHandler, forwardRef } from 'react';

import clsx from 'clsx';
import Select from 'react-select';

export const ReactSelect = forwardRef(function ReactSelect(props, ref) {
  return (
    <Select
      {...props}
      ref={ref}
      classNamePrefix={props.classNamePrefix ?? 'rs'}
      className={clsx('rs-container', props.className)}
      onBlur={fixBlur(props.onBlur)}
    />
  );
}) as typeof Select;

export function fixBlur(onBlur?: FocusEventHandler<HTMLInputElement>) {
  return (event: FocusEvent<HTMLInputElement>) => {
    focusRelatedElementOnBlur(event);
    onBlur?.(event);
  };
}

function focusRelatedElementOnBlur(event: FocusEvent<HTMLInputElement>) {
  const element = event.relatedTarget as HTMLElement | null;
  const tabIndex = element?.attributes.getNamedItem('tabindex')?.value;

  if (
    Number(tabIndex) >= 0 ||
    [
      'INPUT',
      'BUTTON',
      'A',
      'SELECT',
      'TEXTAREA',
      'AREA',
      'OBJECT',
      'IFRAME',
      'SUMMARY',
    ].includes(element?.tagName ?? '')
  ) {
    element?.focus();
  }
}
